// @ts-nocheck
import { FC, memo } from 'react';
import { Box, IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';
import { IUser } from 'types/UserData.types';
import { IResourceInfo } from 'pages/ProjectBudget/DayworkDocket/ResourceMapping/common/api/types';
import { formatDate } from 'utils/dateUtils';
import ResourceInfo from './ResourceInfo';
import { LightTooltip } from '../style';
import { useUser } from '../../../../hooks';
import { archiveAccountingCodeSpanStyle } from './resourceinfo.styles';

interface ResourceMoreInfoProps {
  resourceInfo: IResourceInfo;
}
interface ResourceInfoWithTooltipProps {
  resourceInfo: IResourceInfo;
  placement?: string;
}

interface IUseUser {
  user: IUser;
}

const ResourceMoreInfo: FC<ResourceMoreInfoProps> = ({ resourceInfo }) => {
  const { user } = useUser() as unknown as IUseUser;
  const isUnitCost =
    user?.data?.dailycosttracking?.view_rates_dailycosttracking;

  return (
    <Box sx={{ width: '280px' }}>
      {resourceInfo?.resource_type?.name && (
        <ResourceInfo
          title="Resource Type"
          subTitle={resourceInfo?.resource_type?.name}
        />
      )}
      {resourceInfo?.accounting_code_details?.accounting_code && (
        <ResourceInfo
          title="Accounting Code"
          subTitle={
            <>
              {resourceInfo?.accounting_code_details?.accounting_code}
              {resourceInfo?.accounting_code_archived && (
                <span style={archiveAccountingCodeSpanStyle}>(Archived)</span>
              )}
              {resourceInfo?.accounting_code_details?.description
                ? ` - ${resourceInfo?.accounting_code_details?.description}`
                : ''}
            </>
          }
        />
      )}
      {resourceInfo?.updated_at && (
        <ResourceInfo
          title="Last Update"
          subTitle={formatDate(
            new Date(resourceInfo?.updated_at),
            'dd/mm/yyyy',
          )}
        />
      )}
      {resourceInfo?.description && (
        <ResourceInfo
          title="Description"
          subTitle={resourceInfo?.description}
        />
      )}
      {resourceInfo?.unit_cost > 0 && isUnitCost && (
        <ResourceInfo
          title="Unit Cost"
          subTitle={`$ ${resourceInfo?.unit_cost}`}
        />
      )}
      {resourceInfo?.unit && (
        <ResourceInfo title="Unit" subTitle={resourceInfo?.unit} />
      )}
    </Box>
  );
};
const ResourceInfoWithTooltip: FC<ResourceInfoWithTooltipProps> = ({
  resourceInfo,
  placement = 'right',
}) => (
  <LightTooltip
    title={<ResourceMoreInfo resourceInfo={resourceInfo} />}
    placement={placement || 'right'}
  >
    <IconButton>
      <Info sx={{ color: 'rgba(95, 109, 131, 1)', fontSize: '18px' }} />
    </IconButton>
  </LightTooltip>
);

export default memo(ResourceInfoWithTooltip);
